// Footer Content
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Social from '../common/Social';

const Wrapper = styled.div`
  .year {
    padding-right: 6px;
  }
  div,
  span,
  p {
    font-size: 0.7rem;
  }
`;
const Design = styled.p`
  font-size: 0.6rem !important;
  padding-top: 10px;
`;
function getYear() {
  return new Date().getFullYear();
}

const FooterContent = ({ ...props }) => {
  return (
    <Wrapper className="footer-footer-content">
      <div className="uk-width-1-1 uk-padding-large-sides">
        <p className="uk-margin-bottom:">
          <span className="year">&#169; {getYear()}</span>
          <span>{props.text1} </span>
          <Social
            className=" "
            url={props.social1Url}
            icon={props.social1Icon}
            aria={props.social1Aria}
          />
          <span className="pipe">|</span>
          <span>{props.text2}</span>
          <Social url={props.social2Url} icon={props.social2Icon} aria={props.social2Aria} />

          <span className="pipe">|</span>
          <a href={props.social3Url}>{props.text3}</a>
          <Social url={props.social3Url} icon={props.social3Icon} aria={props.social3Aria} />
        </p>
        <p>
          {props.text4}
          <span className="pipe">|</span>
          <a href={props.phoneUrl} role="button">
            {props.phone}
          </a>
        </p>
        <Design>
          {props.design} <a href={props.designUrl}>{props.designLink}</a>
        </Design>
      </div>
    </Wrapper>
  );
};

FooterContent.propTypes = {
  text1: PropTypes.string,
  text2: PropTypes.string,
  text3: PropTypes.string,
  social1Url: PropTypes.string,
  social1Icon: PropTypes.string,
  social1Aria: PropTypes.string,
  social2Url: PropTypes.string,
  social2Icon: PropTypes.string,
  social2Aria: PropTypes.string,
  phoneUrl: PropTypes.string,
  phone: PropTypes.string,
};

export default FooterContent;



// WEBPACK FOOTER //
// ./src/features/footer/FooterContent.js